export class AttributeValue {
    key: string;
    value: string;

    constructor(av: AttributeValue) {
        if (av != null) {
            this.key = av.key;
            this.value = av.value;
        }
    }
}
